import styled from 'styled-components'

const ModalLongText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 1.5em auto;
  padding: 1em 1em 0 1em;
  background: rgba(241, 241, 241, 0.05);
  border-radius: 1rem;
`

export default ModalLongText